import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { ArrowRight, Sparkles } from 'lucide-react';
import { toast } from 'sonner';

export const FinalCTA = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Mock submission
    setTimeout(() => {
      toast.success('Welcome to Fuzz! We\'ll notify you at launch.');
      setEmail('');
      setLoading(false);
    }, 1000);
  };

  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 via-emerald-600 to-green-600 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          {/* Icon */}
          <div className="mb-8 flex justify-center">
            <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm animate-pulse">
              <Sparkles className="h-10 w-10 text-white" />
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Bring your people closer.
          </h2>
          
          <p className="text-xl md:text-2xl text-teal-50 mb-12 leading-relaxed">
            Join the waitlist and be among the first to experience proximity reimagined.
          </p>

          {/* Email Form */}
          <form onSubmit={handleSubmit} className="max-w-md mx-auto mb-8">
            <div className="flex flex-col sm:flex-row gap-4">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 h-14 px-6 text-lg bg-white/95 backdrop-blur-sm border-none rounded-full"
              />
              <Button
                type="submit"
                disabled={loading}
                size="lg"
                className="h-14 px-8 bg-white text-teal-600 hover:bg-teal-50 font-semibold rounded-full transition-all hover:scale-105 hover:shadow-xl"
              >
                {loading ? 'Joining...' : 'Join Waitlist'}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </form>

          {/* Alternative CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-6 rounded-full transition-all hover:scale-105"
            >
              Build Your Vibe
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-6 rounded-full transition-all hover:scale-105"
            >
              Learn More
            </Button>
          </div>

          {/* Trust indicator */}
          <p className="mt-12 text-teal-100 text-sm">
            🔒 Your email is safe with us. No spam, ever.
          </p>
        </div>
      </div>
    </section>
  );
};
